import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    boxShadow: 'none',
  },
  toolbar: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
  },
  action: {
    margin: 6,
  },
  actionEdit: {
    color: theme.palette.orange.main,
    cursor: 'pointer',
  },
  actionDel: {
    color: theme.palette.red.main,
    cursor: 'pointer',
  },
  actionPush: {
    color: theme.palette.orange.main,
    cursor: 'pointer',
  },
  actionShow: {
    color: theme.palette.green.main,
    cursor: 'pointer',
  },
  actionModalMedic: {
    color: theme.palette.blue.main,
    cursor: 'pointer',
  },
  actionExam: {
    color: theme.palette.purple.main,
    cursor: 'pointer',
  }
}));
